/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_SeatsInputs */

const en_field_seats = /** @type {(inputs: Field_SeatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seats`)
};

const es_field_seats = /** @type {(inputs: Field_SeatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asientos`)
};

const fr_field_seats = /** @type {(inputs: Field_SeatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sièges`)
};

const de_field_seats = /** @type {(inputs: Field_SeatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sitzplätze`)
};

const ja_field_seats = /** @type {(inputs: Field_SeatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`座席数`)
};

const zh_field_seats = /** @type {(inputs: Field_SeatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`座位数`)
};

const ar_field_seats = /** @type {(inputs: Field_SeatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المقاعد`)
};

const id_field_seats = /** @type {(inputs: Field_SeatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kursi`)
};

const it_field_seats = /** @type {(inputs: Field_SeatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posti a Sedere`)
};

const ru_field_seats = /** @type {(inputs: Field_SeatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Количество мест`)
};

const pt_field_seats = /** @type {(inputs: Field_SeatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assentos`)
};

const ko_field_seats = /** @type {(inputs: Field_SeatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`좌석`)
};

/**
* | output |
* | --- |
* | "Seats" |
*
* @param {Field_SeatsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_seats = /** @type {((inputs?: Field_SeatsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_SeatsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_seats(inputs)
	if (locale === "es") return es_field_seats(inputs)
	if (locale === "fr") return fr_field_seats(inputs)
	if (locale === "de") return de_field_seats(inputs)
	if (locale === "ja") return ja_field_seats(inputs)
	if (locale === "zh") return zh_field_seats(inputs)
	if (locale === "ar") return ar_field_seats(inputs)
	if (locale === "id") return id_field_seats(inputs)
	if (locale === "it") return it_field_seats(inputs)
	if (locale === "ru") return ru_field_seats(inputs)
	if (locale === "pt") return pt_field_seats(inputs)
	return ko_field_seats(inputs)
});